import { TenantEntity } from '../TenantEntity'

export class RailwayContainer extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get eqsize() {
    return this._data.eqsize
  }
  set eqsize(eqsize) {
    this._data.eqsize = eqsize
  }
  get eqtype() {
    return this._data.eqtype
  }
  set eqtype(eqtype) {
    this._data.eqtype = eqtype
  }
  get containerno() {
    return this._data.containerno
  }
  set containerno(containerno) {
    this._data.containerno = containerno
  }
  get unitPrice() {
    return this._data.unitPrice
  }
  set unitPrice(unitPrice) {
    this._data.unitPrice = unitPrice || 0
  }
  get containerStatus() {
    return this._data.containerStatus
  }
  set containerStatus(containerStatus) {
    this._data.containerStatus = containerStatus || 0
  }
  get containerAscription() {
    return this._data.containerAscription
  }
  set containerAscription(containerAscription) {
    this._data.containerAscription = containerAscription || 0
  }
  get jobNo() {
    return this._data.jobNo
  }
  set jobNo(jobNo) {
    this._data.jobNo = jobNo
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
  get containerUuid() {
    return this._data.containerUuid
  }
  set containerUuid(containerUuid) {
    this._data.containerUuid = containerUuid
  }
  get currencyCode() {
    return this._data.currencyCode
  }
  set currencyCode(currencyCode) {
    this._data.currencyCode = currencyCode
  }
  get orderUuid() {
    return this._data.orderUuid
  }
  set orderUuid(orderUuid) {
    this._data.orderUuid = orderUuid
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
}
